import { Injectable } from '@angular/core';
import { map, mergeMap, take } from 'rxjs/operators';
import { widgetsTypes, WidgetService } from '../services/widget.service';

@Injectable()
export class WidgetResolver {

  private mainWidgetInstanceId: number;

  constructor(
    private widgetService: WidgetService) {}

  init() {
    return this.widgetService.getWidgetV3InstanceId(widgetsTypes.mainWidget).pipe(
      take(1),
      mergeMap(mainWidgetInstanceId => {
        this.mainWidgetInstanceId = mainWidgetInstanceId;
        return this.widgetService.fetchWidgetCustomizations(mainWidgetInstanceId);
      }),
      map((widgetCustomization) => {
        return {
          mainWidget: {
            widgetInstanceId: this.mainWidgetInstanceId,
            widgetCustomization: {
              primaryColor: widgetCustomization.response.color_primary,
              starsColor: widgetCustomization.response.color_stars,
              font: widgetCustomization.response.font_type
            },
          }
        };
      }));
  }
}
